export const firebaseConfig = {
    apiKey: "AIzaSyDgwumdff20OvuC4lgZc1-FuiAVuH8LmDc",
    authDomain: "rotobot-ai.firebaseapp.com",
    projectId: "rotobot-ai",
    storageBucket: "rotobot-ai.appspot.com",
    messagingSenderId: "62104652584",
    appId: "1:62104652584:web:f219756c3a769f2aa2de1d",
    measurementId: "G-JHP3WK1GPS",
};